export const pagesWithUnsavedChanges = [
  'dnd',
  'risks',
  'controls',
  'businessProcessesL1',
  'businessProcessesL2',
  'businessProcessesL3',
  'businessProcesses',
  'allocation',
  'processAllocation',
  'controlsTesting',
  'controlsTestingDesignEffectiveness'
];
